export default "__VITE_ASSET__BAhQ$9vO__"